import CrossHairsGpsIcon from '../assets/crosshairs-gps.svg'
import {styles} from '../styles'

export const UserLocationButton = (
  handleMapClick: (coords: {lat: number; lng: number}) => void
) => {
  const useLocationButton = document.createElement('button')
  useLocationButton.innerHTML = `<img src="${CrossHairsGpsIcon}" alt="My Location" width="16" height="16" />`

  Object.assign(useLocationButton.style, {
    background: styles.locationButton.background,
    border: styles.locationButton.border,
    borderRadius: styles.locationButton.borderRadius,
    cursor: styles.locationButton.cursor,
    width: styles.locationButton.width,
    height: styles.locationButton.height,
    margin: styles.locationButton.margin,
    display: styles.locationButton.display,
    alignItems: styles.locationButton.alignItems,
    justifyContent: styles.locationButton.justifyContent
  })

  useLocationButton.onmouseover = () => {
    useLocationButton.style.backgroundColor = styles.locationButtonHover.backgroundColor
  }

  useLocationButton.onmouseout = () => {
    useLocationButton.style.backgroundColor = styles.locationButton.background
  }

  useLocationButton.addEventListener('click', () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        const pos = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        }
        handleMapClick(pos)
      })
    }
  })

  return useLocationButton
}
